import * as $ from 'jquery';
import 'bootstrap';

export class bookingWidget{

  showmoredest(): any{
    let _self = this;
  }
}
